import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pwa-xl"
}
const _hoisted_2 = { class: "pwa" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "46",
    height: "52",
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 6.47974C0 2.90108 2.90108 0 6.47974 0H39.5264C43.1051 0 46.0062 2.90108 46.0062 6.47974C46.0062 10.0584 43.1051 12.9595 39.5264 12.9595H6.47975C2.90109 12.9595 0 10.0584 0 6.47974Z",
      fill: "#079F72"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 22.679C0 19.1003 2.90108 16.1992 6.47974 16.1992H27.8629C31.4416 16.1992 34.3426 19.1003 34.3426 22.679C34.3426 26.2576 31.4415 29.1587 27.8629 29.1587H6.47974C2.90108 29.1587 0 26.2576 0 22.679Z",
      fill: "#079F72"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      y: "32.3989",
      width: "12.9595",
      height: "19.6012",
      rx: "6.47974",
      fill: "#079F72"
    })
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Instale o Fluxoo"),
    /*#__PURE__*/_createElementVNode("h2", null, "Seu controle de documentos em poucos cliques, direto no seu computador.")
  ])
], -1)
const _hoisted_4 = {
  key: 1,
  class: "pwa-sm"
}
const _hoisted_5 = { class: "pwa" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "46",
    height: "52",
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 6.47974C0 2.90108 2.90108 0 6.47974 0H39.5264C43.1051 0 46.0062 2.90108 46.0062 6.47974C46.0062 10.0584 43.1051 12.9595 39.5264 12.9595H6.47975C2.90109 12.9595 0 10.0584 0 6.47974Z",
      fill: "#079F72"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 22.679C0 19.1003 2.90108 16.1992 6.47974 16.1992H27.8629C31.4416 16.1992 34.3426 19.1003 34.3426 22.679C34.3426 26.2576 31.4415 29.1587 27.8629 29.1587H6.47974C2.90108 29.1587 0 26.2576 0 22.679Z",
      fill: "#079F72"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      y: "32.3989",
      width: "12.9595",
      height: "19.6012",
      rx: "6.47974",
      fill: "#079F72"
    })
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Instale o Fluxoo"),
    /*#__PURE__*/_createElementVNode("h2", null, "Seu controle de documentos em poucos cliques, direto no seu dispositivo.")
  ])
], -1)

import { ref } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import usePWA from '@/hooks/usePWA'


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallPWAModal',
  setup(__props) {

const isInstallPwaModalOpen = ref<boolean>(true)
const pwa = usePWA()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(pwa).deferredPrompt.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MyModal, {
            isOpen: isInstallPwaModalOpen.value,
            class: _normalizeClass('pwa-modal'),
            toggleModal: (v) => isInstallPwaModalOpen.value = v,
            width: '806px',
            height: '113px',
            zIndex: 10
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {isInstallPwaModalOpen.value = false;})
                  }, "Agora não"),
                  _createElementVNode("input", {
                    type: "button",
                    value: "instalar",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(pwa).install(); isInstallPwaModalOpen.value = false})
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["isOpen", "toggleModal"])
        ]))
      : _createCommentVNode("", true),
    (_unref(pwa).deferredPrompt.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(MyModal, {
            isOpen: isInstallPwaModalOpen.value,
            class: _normalizeClass('pwa-modal'),
            toggleModal: (v) => isInstallPwaModalOpen.value = v,
            height: '342px',
            zIndex: 10
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {isInstallPwaModalOpen.value = false;})
                  }, "Agora não"),
                  _createElementVNode("input", {
                    type: "button",
                    value: "instalar",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_unref(pwa).install(); isInstallPwaModalOpen.value = false})
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["isOpen", "toggleModal"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})